import styled from 'styled-components'

export const TimeStamp = styled.span`
    font-weight: normal;
    font-size: 12px;
    line-height: 17px;
    margin-left: 3px;
`
